import {useContext} from 'react';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {useUyo} from '~/common/fabric/Card/hooks/useUyo';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {DeleteIcon} from '~library/svg/DeleteIcon';
import {charcoal, pebble} from '~libSass/base/_exports.sass';

import './DeleteButton.sass';

export const DeleteButton = ({btnText = '', disabled, semibold = false}) => {
  const {processing} = useContext(EventCreateContext);
  const {removeUYOImage} = useUyo();

  const pending = processing || disabled;

  return (
    <Button
      variant="secondary"
      size="large"
      fullWidth
      className="delete-uyo-button"
      onClick={() => removeUYOImage()}
      data-qa-id="delete-uyo-button"
      disabled={processing}
    >
      <DeleteIcon
        className="action_button__upload"
        color={pending ? pebble : charcoal}
        ratio={1.25}
      />
      {btnText && (
        <Typography variant="paragraph3" size="medium" color={pending ? 'pebble' : 'charcoal'}>
          {btnText}
        </Typography>
      )}
    </Button>
  );
};
